var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportWalk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0c10.493 0 19 8.507 19 19s-8.507 19-19 19S0 29.493 0 19 8.507 0 19 0zm0 2C9.626 2 2 9.626 2 19c0 9.374 7.626 17 17 17 9.374 0 17-7.626 17-17 0-9.374-7.626-17-17-17zm.416 9.515l.072.003h.015c.058 0 .117-.009.173.001l.052.012c.01.003.02 0 .03.002.041.012.073.04.112.056.053.022.11.036.16.067.017.011.032.025.05.037.046.033.08.075.12.115.038.04.08.072.111.117.006.008.015.012.021.02l1.81 2.714 2.674.892a1 1 0 01-.633 1.897l-3-1a.995.995 0 01-.515-.394l-.773-1.158-.943 3.537 2.602 1.735c.256.17.42.448.443.755l.5 6.5a1 1 0 01-1.994.153l-.463-6.014-1.632-1.088-1.943 7.284a.999.999 0 11-1.93-.516l3.561-13.36-1.772.442-.855 3.418a.998.998 0 01-1.212.728.999.999 0 01-.727-1.213l1-4a.998.998 0 01.727-.727l4-1c.01-.003.02 0 .028-.002.02-.004.04-.008.058-.01.048-.009.097 0 .145 0zM20.5 7.5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconTransportWalk;